function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.841156,
  width: 60,
  height: 60,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1554_1262)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.8412 10.75L14.5912 12.5H12.8412C12.3412 12.5 11.8828 12.7083 11.4662 13.125C11.0495 13.5417 10.8412 14 10.8412 14.5V38C10.8412 38.5833 11.0287 39.0625 11.4037 39.4375C11.7787 39.8125 12.2578 40 12.8412 40H39.5912L6.09116 6.5L7.34116 5.25L53.2162 51.125L51.9662 52.375L41.3412 41.75H32.5912V46.75H37.5912V48.5H24.0912V46.75H29.0912V41.75H12.8412C11.7578 41.75 10.862 41.3958 10.1537 40.6875C9.44532 39.9792 9.09116 39.0833 9.09116 38V14.5C9.09116 13.4167 9.44532 12.5208 10.1537 11.8125C10.862 11.1042 11.7578 10.75 12.8412 10.75ZM50.5287 41.375L49.1537 40C49.5703 39.9167 49.9557 39.7083 50.3099 39.375C50.6641 39.0417 50.8412 38.5833 50.8412 38V14.5C50.8412 13.9167 50.6537 13.4375 50.2787 13.0625C49.9037 12.6875 49.4245 12.5 48.8412 12.5H21.6537L19.9037 10.75H48.8412C49.9245 10.75 50.8203 11.1042 51.5287 11.8125C52.237 12.5208 52.5912 13.4167 52.5912 14.5V38C52.5912 38.75 52.4037 39.4271 52.0287 40.0312C51.6537 40.6354 51.1537 41.0833 50.5287 41.375Z",
  fill: "white"
}));

function SvgCrossMonitor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1554_1262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 60
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossMonitor);
export default __webpack_public_path__ + "static/media/crossMonitor.5c17acad.svg";
export { ForwardRef as ReactComponent };